// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODIFIED DATA : 07-12-2025

const BranchProfileReportActionTypes = {
	/****************** FETCH BRANCH PROFILE START ********************** */
	GET_BRANCH_PROFILE_REPORT_START: 'get_branch_profile_report_start',
	GET_BRANCH_PROFILE_REPORT_SUCCESS: 'get_branch_profile_report_success',
	GET_BRANCH_PROFILE_REPORT_FAILURE: 'get_branch_profile_report_failure',
	GET_BRANCH_PROFILE_REPORT_RESPONSE_RESET: 'get_branch_profile_report_response_reset',
	GET_BRANCH_PROFILE_REPORT_RESPONSE_CHANGED: 'get_branch_profile_report_response_changed',
	/****************** FETCH BRANCH PROFILE END ********************** */
};
export default BranchProfileReportActionTypes;
